import { alpha } from '@mui/material'
import { getPaletteValue } from './MuiChip'
import type { OmuiChipWithActionButtonComponent } from '@omnea-app/omui/ChipWithActionButton'

export const OmuiChipWithActionButton: OmuiChipWithActionButtonComponent = {
  styleOverrides: {
    root: ({ theme, ownerState }) => ({
      display: 'inline-flex',
      alignItems: 'center',
      minWidth: 0,
      borderRadius: '16px',
      border: `1px solid ${alpha(theme.palette.text.primary, 0.26)}`,
      overflow: 'hidden',
      backgroundColor: getPaletteValue(theme, ownerState?.color, 'light'),
    }),
    chip: {
      border: 'none',
      borderRadius: '16px 0 0 16px',
      backgroundColor: 'transparent',
      flex: '1 1 auto',
      minWidth: 0,
      '& .MuiChip-icon': { marginLeft: '8px' },
      '& .MuiChip-label': { paddingRight: '6px' },
    },
    actionButtonSlot: ({ theme }) => ({
      display: 'flex',
      alignItems: 'center',
      flexShrink: 0,
      paddingRight: theme.spacing(0.5),
    }),
  },
}
